import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";

const dashboard: IDashboardTemplate = {
    id: 1,
    title: "dashboard.templates.affiliatemarketingoptimization.title",
    description: "dashboard.templates.affiliatemarketingoptimization.description",
    descriptionLong: "dashboard.templates.affiliatemarketingoptimization.description.long",
    keyMetrics: "dashboard.templates.affiliatemarketingoptimization.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/AffiliateMarketingOptimization-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/AffiliateMarketingOptimization-thumb.png"),
    familyType: EFamilyTypes.Website,
    autoFillUserDomain: true,
    minItems: 2,
    maxItems: 5,
    widgets: [
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                selectedChannel: "Referrals",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "1m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Referrals Traffic | Last Month",
                tooltip: "Traffic Share | Referrals.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Referrals",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "12m",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Referrals Traffic | Extended Period",
                tooltip: "Traffic Share | Referrals.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Referrals",
                metric: "ChannelsAnalysisByBounceRate",
                webSource: "Desktop",
                duration: "6m",
                type: "MmxBounceRateDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Bounce Rate - Traffic Referrals",
                tooltip: "Bounce Rate - Traffic Referrals.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 2,
            },
            properties: {
                flexibleDuration: true,
                selectedChannel: "Referrals",
                metric: "ChannelsAnalysisByAverageDuration",
                webSource: "Desktop",
                duration: "6m",
                type: "MmxVisitDurationDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Avg. Visit Duration - Traffic Referrals",
                tooltip: "Avg. Visit Duration - Traffic Referrals.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 0,
                sizeY: 2,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TopReferrals",
                webSource: "Desktop",
                duration: "1m",
                type: "TopReferralsDashboardTable",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Referrals Battleground | Last Month",
                tooltip: "Competitors Battleground.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 2,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TopReferrals",
                webSource: "Desktop",
                duration: "3m",
                type: "TopReferralsDashboardTable",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Referrals Battleground | Last 3 Months",
                tooltip: "Last 3 Months | Competitors Battleground.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 0,
            },
            properties: {
                multiple: true,
                selectedChannel: "Direct",
                metric: "TopReferrals",
                webSource: "Desktop",
                duration: "1m",
                type: "TopReferralsDashboardTable",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                },
                width: "2",
                options: {},
                family: "Website",
                title: "Website Top Referrals",
                tooltip: "Referrals.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 0,
            },
            properties: {
                selectedChannel: "Referrals",
                metric: "TopReferringCategories",
                webSource: "Desktop",
                duration: "1m",
                type: "WWOTopRefCategories",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                options: {},
                family: "Website",
                title: "Top Referring Categories",
                tooltip: "Top Referring Categories.tooltip",
            },
        },
    ],
};
export default dashboard;
